/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const BigNumber = require('bignumber.js');
BigNumber.config({
  ROUNDING_MODE: BigNumber.ROUND_HALF_UP,
  DECIMAL_PLACES: 20
});

module.exports = {
  // BigNumberを使用して与えられた引数全てを足し算した結果をfloatで返します
  add(...args) {
    if (args.length === 0) {
      return 0;
    }
    let result = new BigNumber(`${args.shift() || 0}`);
    result = args.reduce(
      (result, arg) => result.plus(new BigNumber(`${arg || 0}`)),
      result
    );
    return result.toNumber();
  },

  // BigNumberを使用して与えられた引数全てを引き算した結果をfloatで返します
  subtract(...args) {
    if (args.length === 0) {
      return 0;
    }
    let result = new BigNumber(`${args.shift() || 0}`);
    result = args.reduce(
      (result, arg) => result.minus(new BigNumber(`${arg || 0}`)),
      result
    );
    return result.toNumber();
  },

  // BigNumberを使用して与えられた引数全てを掛け算した結果をfloatで返します
  multiply(...args) {
    if (args.length === 0) {
      return 0;
    }
    let result = new BigNumber(`${args.shift() || 0}`);
    result = args.reduce(
      (result, arg) => result.times(new BigNumber(`${arg || 0}`)),
      result
    );
    return result.toNumber();
  },

  // BigNumberを使用して与えられた引数全てを割り算した結果をfloatで返します
  divide(...args) {
    if (args.length === 0) {
      return 0;
    }
    let result = new BigNumber(`${args.shift() || 0}`);
    result = args.reduce(function(result, arg) {
      arg = arg || 0;
      if (arg === 0) {
        throw new Error('Division by zero');
      }
      return result.div(new BigNumber(`${arg}`));
    }, result);
    return result.toNumber();
  }
};
